/**
 * זיהוי קישורי Google Drive והמרתם לכתובת תמונה ישירה שניתן להטמיע ב-<img>.
 * קישור "שיתוף" רגיל של Drive (.../file/d/ID/view) הוא עמוד HTML, לא bytes של
 * תמונה — הטמעה ישירה שלו תציג תמונה שבורה. משתמשים בנקודת הקצה thumbnail,
 * המיועדת בדיוק לשימוש הזה ועובדת גם לקבצים ששותפו כ"כל מי שיש לו את הקישור".
 * הערך הגולמי בגיליון/ב-DB נשאר ללא שינוי — ההמרה מתבצעת רק בזמן תצוגה.
 */

const DRIVE_ID_PATTERNS = [
  /\/file\/d\/([a-zA-Z0-9_-]+)/,
  /[?&]id=([a-zA-Z0-9_-]+)/,
  /\/d\/([a-zA-Z0-9_-]+)/,
];

function extractDriveFileId(url: string): string | null {
  if (!/drive\.google\.com|docs\.google\.com/i.test(url)) return null;
  for (const re of DRIVE_ID_PATTERNS) {
    const m = re.exec(url);
    if (m?.[1]) return m[1];
  }
  return null;
}

/** ממיר קישור Google Drive לכתובת תמונה ישירה; קישורים אחרים מוחזרים כמות שהם */
export function resolveImageUrl(raw: string | null | undefined): string {
  const url = (raw ?? '').trim();
  if (!url) return '';
  const fileId = extractDriveFileId(url);
  if (fileId) return `https://drive.google.com/thumbnail?id=${fileId}&sz=w2000`;
  return url;
}
